module.exports = __webpack_public_path__ + "img/success4.a125c8b9.gif";